import React from 'react';

import { translate } from 'services/i18nService';

import MoneyIcon from '../../../images/broadcaster/rules-money.png';
import VideoIcon from '../../../images/broadcaster/rules-video.png';
import AgeIcon from '../../../images/broadcaster/rules-age.png';
import AbuseIcon from '../../../images/broadcaster/rules-abuse.png';
import DrugUseIcon from '../../../images/broadcaster/rule-drugs.png';

import styles from './BroadcasterPublicChatEmpty.css';


function BroadcasterPublicChatEmpty() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.rulesHeader}>
        <p>
          {translate('v2broadcast.public.chat.empty.rules.header', {
            0: `<span class=${styles.boldText}>`,
            1: '</span>',
          })}
        </p>
      </div>
      <div className={styles.rulesBody}>
        <div className={styles.ruleWrapper}>
          <div className={styles.icon}>
            <img alt="money" src={MoneyIcon} />
          </div>
          <div className={styles.textWrapper}>
            <p className={styles.title}>
              {translate('v2broadcast.public.chat.empty.rules.payment.title')}
            </p>
            <p>
              {translate('v2broadcast.public.chat.empty.rules.payment.body')}
            </p>
          </div>
        </div>
        <div className={styles.ruleWrapper}>
          <div className={styles.icon}>
            <img alt="video" src={VideoIcon} />
          </div>
          <div className={styles.textWrapper}>
            <p className={styles.title}>
              {translate('v2broadcast.public.chat.empty.rules.videos.title')}
            </p>
            <p>
              {translate('v2broadcast.public.chat.empty.rules.videos.body')}
            </p>
          </div>
        </div>
        <div className={styles.ruleWrapper}>
          <div className={styles.icon}>
            <img alt="age" src={AgeIcon} />
          </div>
          <div className={styles.textWrapper}>
            <p className={styles.title}>
              {translate('v2broadcast.public.chat.empty.rules.adults.only.title')}
            </p>
            <p>
              {translate('v2broadcast.public.chat.empty.rules.adults.only.body')}
            </p>
          </div>
        </div>
        <div className={styles.ruleWrapper}>
          <div className={styles.icon}>
            <img alt="abuse" src={AbuseIcon} />
          </div>
          <div className={styles.textWrapper}>
            <p className={styles.title}>
              {translate('v2broadcast.public.chat.empty.rules.no.abusive.language.title')}
            </p>
            <p>
              {translate('v2broadcast.public.chat.empty.rules.no.abusive.language.body')}
            </p>
          </div>
        </div>
        <div className={styles.ruleWrapper}>
          <div className={styles.icon}>
            <img alt="drug use" src={DrugUseIcon} />
          </div>
          <div className={styles.textWrapper}>
            <p className={styles.title}>
              {translate('v2broadcast.public.chat.empty.rules.no.drug.use.title')}
            </p>
            <p>
              {translate('v2broadcast.public.chat.empty.rules.no.drug.use.body')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BroadcasterPublicChatEmpty;
